import React, { Fragment, useState } from "react"
import {
  AppBar,
  Button,
  Box,
  Menu,
  MenuItem,
  IconButton,
  Badge
} from "@material-ui/core"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown"
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp"
import TuneIcon from "@material-ui/icons/Tune"

const ActionBar = ({
  classes,
  dispatch,
  setSort,
  sort,
  filter,
  filters,
  setFilter,
  ...props
}) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [filterEl, setFilterEl] = useState(null)

  const handleSortClick = newSort => {
    if (sort && sort.name === newSort.name) {
      if (sort.dir === "ASC") {
        setSort({ ...newSort, dir: "DESC" })
      } else {
        setSort(null)
      }
    } else {
      setSort({ ...newSort, dir: "ASC" })
    }
  }

  const handleFilterClick = newFilter => {
    if (filter && filter.name === newFilter.name) {
      setFilter(null)
    } else {
      setFilter(newFilter)
    }
  }

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <AppBar elevation={0} position="relative" color="primary">
      <Box
        display="flex"
        alignItems="center"
        className={classes.actionBarWidth}
      >
        {props.buttons && props.buttons}
        <Box flexGrow={1}>
          {props.bulkActions && (
            <div className={classes.BulkActionsContaienr}>
              <Button
                className={classes.BulkActionsButton}
                onClick={handleClick}
                disabled={props.bulkActions.length === 0}
              >
                Bulk Actions <ArrowDropDownIcon />
              </Button>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                {props.bulkActions}
              </Menu>
            </div>
          )}
        </Box>
        {filters && filters.length > 0 ? (
          <Fragment>
            <IconButton onClick={e => setFilterEl(e.currentTarget)}>
              <Badge badgeContent="" variant="dot" invisible={!filter}>
                <TuneIcon />
              </Badge>
            </IconButton>
            <Menu
              anchorEl={filterEl}
              open={Boolean(filterEl)}
              onClose={() => setFilterEl(null)}
            >
              {filters.map((x, i) => {
                const selected = filter && filter.name === x.name
                return (
                  <MenuItem
                    className={classes.filterContainer}
                    key={i}
                    onClick={() => {
                      setFilterEl(null)
                      handleFilterClick(x)
                    }}
                    selected={selected}
                  >
                    <Box className={classes.icon}>{selected && x.icon}</Box>

                    {x.name}
                  </MenuItem>
                )
              })}
            </Menu>
          </Fragment>
        ) : null}
        <Box className={classes.sortsContainer}>
          {props.sorts &&
            props.sorts.map((s, i) => {
              let content = [s.name]
              if (sort && sort.name === s.name) {
                if (sort.dir === "ASC") {
                  content = (
                    <Fragment>
                      <ArrowDropUpIcon /> {content}
                    </Fragment>
                  )
                } else {
                  content = (
                    <Fragment>
                      <ArrowDropDownIcon /> {content}
                    </Fragment>
                  )
                }
              }
              return (
                <Button
                  className={classes.sortName}
                  variant="text"
                  onClick={() => handleSortClick(s)}
                  key={i}
                >
                  {content}
                </Button>
              )
            })}
        </Box>
        {props.searchBar && props.searchBar}
      </Box>
    </AppBar>
  )
}

export default withStyles(styles)(ActionBar)



// WEBPACK FOOTER //
// ./src/components/ActionBar/index.jsx